import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Slider, InputNumber } from 'antd';
import { SettingsContext } from '../../../../hoc/Settings';
import { LocalizationContext } from '../../../../hoc/Localization';
import styles from '../../TopBar/styles.less';

const PriceFilter = ({ price, freeTrial, setPrice, setFreeTrial }) => {
  const {
    domainSettings: { prices },
  } = React.useContext(SettingsContext);
  const { t } = React.useContext(LocalizationContext);
  const [tempPrice, setTempPrice] = React.useState([]);

  const handlePriceChange = value => {
    setPrice(value);
    setTempPrice(value);
  };

  const startMax = ((price && price[1]) || prices.max) - prices.step;
  const endMin = ((price && price[0]) || prices.min) + prices.step;

  return (
    <>
      <p className={styles.note}>{t('search.filters.price.order')}</p>

      <Slider
        range
        defaultValue={price || [prices.min, prices.max]}
        onAfterChange={setPrice}
        onChange={setTempPrice}
        value={(tempPrice.length === 2 && tempPrice) || price || [prices.min, prices.max]}
        {...prices}
      />

      <div className={styles.priceInputs}>
        <InputNumber
          onChange={value => {
            handlePriceChange([value, (price && price[1]) || prices.max]);
          }}
          value={(price && price[0]) || prices.min}
          min={0}
          max={startMax < 0 ? 0 : startMax}
          step={prices.step}
        />

        <span className={styles.dash}>-</span>

        <InputNumber
          onChange={value => {
            handlePriceChange([(price && price[0]) || prices.min, value]);
          }}
          value={(price && price[1]) || prices.max}
          min={endMin}
          step={prices.step}
        />
      </div>

      <p>
        <Checkbox defaultChecked={freeTrial} onChange={e => setFreeTrial(e.target.checked)}>
          {t('search.freetrial')}
        </Checkbox>
      </p>
    </>
  );
};

PriceFilter.propTypes = {
  price: PropTypes.array,
  freeTrial: PropTypes.bool,
  setPrice: PropTypes.func,
  setFreeTrial: PropTypes.func,
};

PriceFilter.defaultProps = {
  price: null,
  freeTrial: false,
  setPrice: () => null,
  setFreeTrial: () => null,
};

export default PriceFilter;
